import type { ReactNode } from 'react';

export const symbol_wifi_device: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M274-180q-39 0-66.5-27.5T180-274v-413q0-39 27.5-66t66.5-27h413q38 0 65.5 27.5T780-687v413q0 39-27 66.5T687-180H274Zm0 60h413q64 0 108.5-45T840-274v-413q0-63-45-108t-108-45H274q-64 0-109 44.5T120-687v413q0 64 45 109t109 45Zm206-475q-49 0-94.5 15T305-533q-10 8-22 9.5t-22-6.5q-10-8-10.5-20.5T259-571q45-42 102-63t119-21q63 0 121.5 21T705-569q8 8 6 19.5T700-530q-9 8-21 8t-21-8q-35-33-81.5-49T480-595Zm1 165q-16 0-31 5t-29 13q-15 10-27 6.5T375-417q-7-8-7-19t9-18q23-17 49-26.5t55-9.5q29 0 55.5 9.5T586-454q9 7 9 18t-7 19q-7 8-19.5 11t-27.5-7q-14-8-29-12.5t-31-4.5Zm-22.5 131.5Q450-307 450-320t8.5-21.5Q467-350 480-350t21.5 8.5Q510-333 510-320t-8.5 21.5Q493-290 480-290t-21.5-8.5ZM480-480Z"
		/>
	</svg>
);
